import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getDeviceChart(state) {
    return state.data
  },
}

export const mutations = {
  SET_DEVICE_CHART_REQUESTED(state) {
    state.loading = true
  },
  SET_DEVICE_CHART_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_DEVICE_CHART_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_DEVICE_CHART(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingDeviceChart({ commit }, params) {
    commit('SET_DEVICE_CHART_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/device/charts/',
        payload: { ...params },
      })
      commit('SET_DEVICE_CHART_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DEVICE_CHART_RECEIVED_FAILED', error)
    }
  },
  async fetchDeviceById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/device/get/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  resetDeviceChart({ commit }) {
    commit('RESET_DEVICE_CHART')
  },
}
